import { cx } from "../../utils/classNames";
import styles from "./AttendanceView.module.css";

// Shown when a check-in/out was recorded outside the branch radius.
const AwayPin = ({ title = "Away from your branch" }) => (
  <i
    className={cx("bi bi-geo-alt-fill", styles.outsidePin)}
    title={title}
    aria-label={title}
  ></i>
);

export default AwayPin;
